import videojs from 'video.js';
import './airplay-button';

const Plugin = videojs.getPlugin('plugin');

const defaultOptions = {};

export default class AirPlay extends Plugin {
	constructor(player, options) {
		super(player);

		this.options = videojs.mergeOptions(defaultOptions, options);

		this.player.ready(() => {
			this.player.addClass('vjs-airplay');
			this.player.addChild('AirPlayButton', options, player.children_.length);
		});
	}

}

// Register the plugin with video.js.
videojs.registerPlugin('airPlay', AirPlay);
